var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-112"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#22CDC8",
    points: "0 13.0001279 5.49992969 18 5.50021094 18 11 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7404557,4.31221124 L22,7.77107974 L19.4116299,10.518504 L15.9776794,6.87434162 C14.2265443,5.02035206 13.2327256,4.45891471 12.3772437,5.36105849 C11.5222543,6.26261277 11.5201002,7.26316691 13.1511066,9.09535189 L13.3465918,9.31049021 L16.8217039,13 L11.6449637,13 L2,2.76243994 L4.60336365,5.70210545e-13 L9.50243999,5.20024025 C9.26692788,4.2489951 9.84135112,2.87941231 10.7784489,1.88447145 C11.9534678,0.636966365 14.2914771,-0.195109779 16.4874645,1.93138452 L16.6994922,2.14649556 L17.0451929,2.51002587 L18.7404557,4.31221124 Z",
    id: "Shape",
    fill: "#383C45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.d041053b5c72994536b9d8c2d742f059.svg";
export { ForwardRef as ReactComponent };